/**
 * 店舗 tab (admin store view, mock v2 2026-10-13): この店舗 ｜ 全店比較.
 * URL: /stores?shop=X&month=M  (この店舗)   /stores?view=all&month=M  (全店比較)
 * Pure helpers — StoresScreen owns the screen, SalonDashboard the route.
 */

/** Off until the store views have content (REACT_APP_STORE_TAB=1). */
export const STORES_TAB_ENABLED = process.env.REACT_APP_STORE_TAB === '1';

/** 'one' = この店舗 (default), 'all' = 全店比較. Anything else is 'one'. */
export function parseStoresView(raw) {
  return raw === 'all' ? 'all' : 'one';
}

// Managers only see their own business's stores, so "全店" would overstate it.
const BUSINESS_BOUND_ROLES = new Set(['manager', 'beauty_manager']);

export function storesViewLabels(role) {
  return {
    one: 'この店舗',
    all: BUSINESS_BOUND_ROLES.has(role) ? '担当店舗の比較' : '全店比較',
  };
}

/** URL params after switching view. store / stylist / month are never touched. */
export function paramsForStoresView(prev, view) {
  const next = new URLSearchParams(prev);
  if (parseStoresView(view) === 'all') next.set('view', 'all');
  else next.delete('view');
  return next;
}

/**
 * The store being looked at in 店舗 lives in its own param, NOT in the home's `store`:
 * picking a store here must not rewrite the home's store or drop its stylist
 * (DashboardContext.updateStore deletes `stylist`).
 */
export const SHOP_PARAM = 'shop';

/** Store shown in 店舗: own `shop` first; the home's `store` is only a read-only starting point. */
export function resolveShop(searchParams) {
  return searchParams.get(SHOP_PARAM) || searchParams.get('store') || null;
}

/** URL params after picking a store in 店舗. Only `shop` changes. */
export function paramsForShop(prev, shop) {
  const next = new URLSearchParams(prev);
  if (shop) next.set(SHOP_PARAM, shop);
  else next.delete(SHOP_PARAM);
  return next;
}

/**
 * 店舗タブの人数ブロックから、管理者タブのスタイリスト一覧（その店舗・同じ月）へ移るときの URL。
 * 管理者タブは別の画面で、店舗は自分で持っている。ここで `store` を書き換えるとホームの選択
 * （store / stylist）まで変わるので、`shop` だけを渡す（AdminScreen が読む）。ホームの選択は壊さない。
 * 店舗タブ専用の view は持ち越さない。
 */
export function paramsForRoster(prev, store, month) {
  const next = new URLSearchParams(prev);
  next.set(SHOP_PARAM, store);
  next.delete('view');
  if (month) next.set('month', month);
  return next;
}
